<script lang="ts" setup>
    const props = defineProps<{
        type?: string,
        page: any
    }>();

    const type = props?.type === undefined ? 'full' : props?.type;
    const page: any = props.page;

    if (page?.featuredImage) {
        useHead({
            link: [
                {
                    href: page?.featuredImage?.node?.mediaItemUrl,
                    fetchpriority: 'high',
                    rel: 'preload',
                    as: 'image',
                }
            ],
        });
    }

    onMounted(() => {
        const logoDiv = document.getElementById('wh-logo-image');
        if (logoDiv) {
            logoDiv.style.backgroundImage = `url('/wh-small-logo.svg')`;
        }
    });
</script>
<template>
    <div id="full-header-image" v-if="type==='full'" class="w-100 bg-dark d-flex align-items-center justify-content-center homepage-cover position-relative">
        <NuxtImg
            v-if="page?.featuredImage?.node?.mediaItemUrl"
            :src="page?.featuredImage?.node?.mediaItemUrl"             
            class="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"             
            style="z-index: 1"             
            format="webp"             
            fetchpriority="high"             
            :quality="75"             
            :width="page?.featuredImage?.node?.mediaDetails?.width"             
            :height="page?.featuredImage?.node?.mediaDetails?.height"          
            sizes="100vw"          
            :modifiers="{                  
                width: { xs: 480, sm: 768, md: 1200, lg: 1920 },                 
                height: { xs: 270, sm: 432, md: 675, lg: 1080 }             
            }"             
            :alt="page?.featuredImage?.node?.title || 'Hero image'"
            loading="eager"         
        />
        <div class="d-flex align-items-center justify-content-center flex-column">
            <h1 class="text-white welcome-label heading z-3 p-3">{{ page?.pageBuilder?.headerCoverDetails?.title }}</h1>
            <button id="get-started-btn" class="btn btn-secondary rounded-pill z-2" data-next-id="nav-stopper">
                GET STARTED
            </button>
        </div>
    </div>
    <div v-else-if="page?.featuredImage != null && page?.featuredImage?.node?.mediaItemUrl" class="w-100 d-flex page-cover pt-5 image-cover">
        <div class="page-cover-wrapper">
            <NuxtImg 
                :src="page?.featuredImage?.node?.mediaItemUrl" 
                :alt="page?.featuredImage?.node?.title" 
                class="page-cover-img"
                format="webp"
                fetchpriority="high"
                quality="80"
                fit="cover"
                :width="1200"
                :height="600"
                :srcset="page?.featuredImage?.node?.srcSet"
                sizes="sm:390 md:1200"
            />
        </div>
        <div class="container-xl d-flex pt-5 title-wrapper">
            <div class="w-100 mt-5 pt-5">
                <h1 class="text-white heading z-3">{{ page?.pageBuilder?.headerCoverDetails?.title }}</h1>
                <div class="col-md-4">
                    <h5 class="text-secondary">
                        {{ page?.pageBuilder?.headerCoverDetails?.description }}
                    </h5>
                </div>
                <div v-if="page?.pageBuilder?.headerCoverDetails?.buttonNavTitle" class="d-flex justify-content-md-start justify-content-center">
                    <button id="get-started-btn" class="btn btn-secondary rounded-pill z-2 text-uppercase mt-md-5 mt-3" data-next-id="nav-stopper">
                        {{ page?.pageBuilder?.headerCoverDetails?.buttonNavTitle }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div v-else-if="page?.pageBuilder?.headerCoverDetails?.backgroundType[0] === 'color'" class="w-100 d-flex page-cover pt-5 bg-primary">
        <div class="container-xl d-flex py-5 title-wrapper">
            <div class="w-100 my-5 pt-5">
                <h1 class="text-white heading z-3">{{ page?.pageBuilder?.headerCoverDetails?.title }}</h1>
                <div class="col-md-4">
                    <h5 class="text-secondary">{{ page?.pageBuilder?.headerCoverDetails?.description }}</h5>
                </div>
            </div>
        </div>
    </div>
    <div v-else id="wh-logo-image" class="w-100 d-flex wh-logo-cover pt-md-5 pt-0">
        <div class="container-xl mb-5 d-flex py-5 title-wrapper align-items-center">
            <div class="w-100 pt-5 text-primary d-flex flex-column justify-content-center align-items-center">
                <h1 class="heading z-3 mb-4">{{ page?.pageBuilder?.headerCoverDetails?.title }}</h1>
                <div class="col-md-4 text-center ff-dm-sans-light" v-html="page?.pageBuilder?.headerCoverDetails?.description">
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.wh-logo-cover .title-wrapper {
    margin-top: 8rem;
}

.image-cover .title-wrapper {
    display: flex;
    padding-bottom: 2rem;
}

#full-header-image::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
    z-index: 2;
    pointer-events: none;
}
</style>